export const teamData = [
  {
    id: 1,
    imgSrc: "images/team1.jpg",
    name: "CH Imtiaz Warraich",
    post: "CEO & Founder",
    phone: "0300-4516820",
  },
  {
    id: 2,
    imgSrc: "images/team2.jpg",
    name: "Waqar Younas Warraich",
    post: "Director",
    phone: "0324-4074244",
  },
  {
    id: 3,
    imgSrc: "images/team3.jpg",
    name: "M.Iqbal",
    post: "Chief Adviser",
    phone: "0322-8483876",
  },
  {
    id: 4,
    imgSrc: "images/team4.jpg",
    name: "Qaisar Bashir",
    post: "General Manager",
    phone: "0322-4274625",
  },
];
